export const MONTH_PAYMENT_EXPERIMENT = 'month'
export const FULL_PAYMENT_EXPERIMENT = 'year'

export const RENEW_UPGRADE_EXPERIMENT_092023 = 'RENEWQATARUPGRADEDISCOUNT092023'
const generateGroup = (group) => {
  return `${RENEW_UPGRADE_EXPERIMENT_092023}-${group}`
}

export const AB_TESTING_GROUPS = {
  A1: generateGroup('A1'),
  A2: generateGroup('A2'),
  B1: generateGroup('B1'),
  B2: generateGroup('B2')
}
